<template>
  <div>
    <a-input-search v-model="searchValue"
                    @change="onChange"
                    allowClear
                    :placeholder="$t('label.pleaseEnterDepartmentName')" />
    <div class="tree-box">
      <!-- 组织机构树 -->
      <a-tree showLine
              :expanded-keys="expandedKeys"
              :selectedKeys="selectedKeys"
              @select="onSelect"
              :treeData="departTree"
              :auto-expand-parent="autoExpandParent"
              @expand="onExpand">
        <template slot="title" slot-scope="{ title }">
          <span v-if="title.indexOf(searchValue) !== -1">
            {{ title.substr(0, title.indexOf(searchValue)) }}
            <span style="color: #f50">{{ searchValue }}</span>
            {{ title.substr(title.indexOf(searchValue) + searchValue.length) }}
          </span>
          <span v-else>{{ title }}..</span>
        </template>
      </a-tree>
    </div>
  </div>
</template>

<script>
import { queryMyDistDeptTreeList, searchByKeywords } from '@api/api'

const getParentKey = (key, tree) => {
  let parentKey = ''
  for (let i = 0; i < tree.length; i++) {
    const node = tree[ i ]
    if (node.children) {
      if (node.children.some(item => item.key === key)) {
        parentKey = node.key
      } else if (getParentKey(key, node.children)) {
        parentKey = getParentKey(key, node.children)
      }
    }
  }
  return parentKey
}

export default {
  name: 'OrganizationTree',
  data() {
    return {
      searchValue: '',
      checkedKeys: '',
      // 选中节点key
      selectedKeys: [],
      // 展开节点key
      expandedKeys: [],
      // 初始化只展开第一层的key
      baseExpandedKeys: [],
      loading: false,
      autoExpandParent: true,
      treeData: [],
      departTree: []
    }
  },
  created() {
    this.loadTree()
  },
  methods: {
    // 获取树的数据
    loadTree() {
      this.treeData = []
      this.departTree = []
      queryMyDistDeptTreeList().then((res) => {
        if (!res.result) return
        let data = res.result
        data.forEach(ele => {
          this.setThisExpandedKeys(ele)
        })
        this.departTree = data
        this.changeTreeData(data)
      }).finally(() => this.loading = false)
    },
    // 树数据扁平化
    changeTreeData(data) {
      data.forEach(ele => {
        this.treeData.push(ele)
        if (ele.children) {
          this.changeTreeData(ele.children)
        }
      })
    },
    // 设置初始展开节点
    setThisExpandedKeys(node) {
      //只展开一级目录
      if (node.children && node.children.length > 0) {
        this.expandedKeys.push(node.key)
        //下方代码放开注释则默认展开所有节点
        /**
         for (let a = 0; a < node.children.length; a++) {
            this.setThisExpandedKeys(node.children[a])
          }
         */
      }
      this.baseExpandedKeys = [...this.expandedKeys]
    },
    // 查询树输入框
    onChange(e) {
      let value = e.target.value
      if (!value) return this.expandedKeys = this.baseExpandedKeys
      this.onSearch(value)
    },
    // 搜索树
    onSearch(value) {
      const expandedKeys = this.treeData.map(item => {
        if (item.title.indexOf(value) > -1) {
          return getParentKey(item.key, this.departTree)
        }
        return null
      }).filter((item, i, self) => item && self.indexOf(item) === i)
      Object.assign(this, {
        expandedKeys,
        autoExpandParent: true
      })
    },
    // 选中树节点
    onSelect(selectedKeys, e) {
      if (this.selectedKeys[ 0 ] !== selectedKeys[ 0 ]) {
        this.selectedKeys = [selectedKeys[ 0 ]]
      }
      let record = e.node.dataRef
      this.checkedKeys = record.id
      this.$emit('selected', record)
    },
    // 点击展开下级
    onExpand(expandedKeys) {
      this.expandedKeys = expandedKeys
      this.autoExpandParent = false
    }
  }
}
</script>

<style lang="less" scoped>
.tree-box {
  margin-top: 10px;
  height: calc(80vh - 135px);
  overflow-y: auto;
}
</style>